import { render, staticRenderFns } from "./CourseDataTable.vue?vue&type=template&id=393f4d7c&"
import script from "./CourseDataTable.vue?vue&type=script&lang=js&"
export * from "./CourseDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports